/**
 * Page scroll lock while a window is open — behaviour of resources/js/Composables/useScrollLock.ts.
 *
 * Shared lock: several windows may be open at once, the page scrolls again only when the
 * last one closes, with its original styles. `overflow: hidden` goes on <html> (the page
 * scroll) and on <body> (convention read elsewhere, e.g. marketplace/mobile-scroll-chrome.ts).
 * Locking <body> alone is not the same: the page under the modal then ends up at another
 * scroll position than Vue's once a modal field is filled (saved searches rename, mobile).
 */
let locks = 0;
let saved: { html: string; body: string } | null = null;

export function lockScroll(): void {
    locks += 1;
    if (locks > 1) return;
    const { documentElement: html, body } = document;
    saved = { html: html.style.overflow, body: body.style.overflow };
    html.style.overflow = "hidden";
    body.style.overflow = "hidden";
}

export function unlockScroll(): void {
    if (locks === 0) return;
    locks -= 1;
    if (locks === 0 && saved) {
        document.documentElement.style.overflow = saved.html;
        document.body.style.overflow = saved.body;
        saved = null;
    }
}
